import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { ClientLogService } from '../services/client-log.service';
import {SystemStateService} from '../services/system-state.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private rejectionHandlerRegistered = false;

  constructor(private injector: Injector) {
    this.registerUnhandledRejection();
  }

  handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      // HTTP errors are handled by the interceptor logging.
      return;
    }

    const message = this.getMessage(error);
    const stack = this.getStack(error);
    this.clientLogger().log('ERROR', message, stack, { source: 'angular' });
      this.systemState().showUnexpectedError(message);
  }

    private systemState(): SystemStateService {
        return this.injector.get(SystemStateService);
  }

  private clientLogger(): ClientLogService {
    return this.injector.get(ClientLogService);
  }

  private getMessage(error: any): string {
    if (typeof error === 'string') {
      return error;
    }
    if (error?.message) {
      return error.message;
    }
    return 'Unknown client error';
  }

  private getStack(error: any): string {
    if (error?.stack) {
      return error.stack;
    }
    return '';
  }

  private registerUnhandledRejection() {
    if (this.rejectionHandlerRegistered || typeof window === 'undefined') {
      return;
    }
    this.rejectionHandlerRegistered = true;

    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
      const reason: any = event.reason;
      const message = this.getMessage(reason);
      const stack = this.getStack(reason);
      this.clientLogger().log('ERROR', message, stack, { source: 'promise' });
        this.systemState().showUnexpectedError(message);
    });
  }
}
